exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user {\n  border-radius: 25px;\n  clear: both;\n  background: #F0F6F9;\n  margin-top: 10px; }\n  .user:nth-child(1) {\n    margin-top: 20px; }\n  .user img {\n    width: 50px;\n    height: 50px;\n    border-radius: 25px;\n    float: left; }\n  .user .description {\n    float: left;\n    width: 148px;\n    padding: 0 5px; }\n  .user .name {\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: bold; }\n  .user .caption {\n    font-size: 12px; }\n  .user .btn {\n    border-radius: 25px;\n    margin: 10px;\n    background: #808988;\n    float: right;\n    width: 130px;\n    font-weight: bold;\n    text-align: center;\n    color: white;\n    font-size: 15px; }\n    .user .btn.active {\n      background: #343F3C; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/users/modals/user.modal.component.scss
// module id = ../../../../../src/app/main/users/modals/user.modal.component.scss
// module chunks = 1